import { TEMPLATES } from "../templates";

import type { HabitTemplate } from "../templates";

export const ONBOARDING_COPY = {
  // Step 1
  welcomeTitle: "Track your habits",
  welcomeSubtitle: "Keep showing up.",
  habitPrompt: "What's one habit you'd like to build?",
  createYourOwn: "Create your own",
  postCreation: "Nice — you're tracking. Come back tomorrow to keep it going.",

  // Step 2
  step2Title: "Completely free. Your data stays on your device.",
  step2Subtitle:
    "Your habits live on your device and sync only when you choose. Built to keep your data yours.",
  step2ScorePreview:
    "We'll track your consistency with a forgiving score — it rewards showing up, not perfection.",
  step2PrivacyLink: "Learn more about your privacy",

  // Step 3
  step3Title: "Check it off now?",
  step3Subtitle:
    "You just created your first habit. If now's a good time, mark it done — small wins count.",
  step3Skip: "I'll do it later",
  step3Done: "Done!",
} as const;

/** IDs of templates curated for onboarding (order matters) */
const STARTER_IDS = [
  "t-water",
  "t-read",
  "t-workout",
  "t-meditate",
  "t-sleep-early",
  "t-journal",
] as const;

export const STARTER_TEMPLATES: HabitTemplate[] = STARTER_IDS.map((id) => {
  const t = TEMPLATES.find((tpl) => tpl.id === id);
  if (!t) throw new Error(`Starter template "${id}" not found`);
  return t;
});
